import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { useMount } from 'ahooks';
import Report from './report';
import { getReportBySystemTypeApi } from '@intelligence/services/reportService';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@intelligence/utils/buriedPointCfg';
import { pageReportTypeConfig } from './_config';

const AIHubReports: React.FC = () => {
  const { formatMessage } = useIntl();

  const segmentList = useMemo(
    () => [
      {
        id: 'all',
        label: formatMessage({ id: 'dbi_all' }),
        pagePoint: dbiPageLogMes.aiHubReports,
      },
      {
        id: 'Game AI',
        label: formatMessage({ id: 'dbi_ai_hub_reports_game_ai' }),
        pagePoint: dbiPageLogMes.aiHubReportsGameAI,
      },
      {
        id: 'AI Assets',
        label: formatMessage({ id: 'dbi_ai_hub_reports_ai_assets' }),
        pagePoint: dbiPageLogMes.aiHubReportsAIAssets,
      },
    ],
    [formatMessage],
  );

  useMount(() => {
    buriedPointPage(dbiPageLogMes.aiHubReports);
  });

  return (
    <Report
      reportType="aiHubReports"
      searchType="aiHubReportsSearch"
      title={formatMessage({ id: 'dbi_ai_hub_reports' })}
      subTitle={formatMessage({ id: 'dbi_ai_hub_reports_intro' })}
      segmentList={segmentList}
      // 接口
      // getReportFun={getInsightsReportListApi}
      getReportFun={() => getReportBySystemTypeApi('intelligence_ai')}
      pageLogMes={dbiPageLogMes.aiHubReports}
      reportTypeConfig={pageReportTypeConfig.aiHubReports}
    />
  );
};

export default AIHubReports;
